<template>
  <iframe
    src="/static/resume_latest.pdf"
    frameborder="0"
    style="width: 100%; height: 100vh"
  ></iframe>
</template>

<script>
export default {
  name: "CV",
};
</script>
